import * as React from 'react'

import { observer } from 'mobx-react'

import IBasicProps from '~/client/src/shared/interfaces/IBasicProps'

@observer
export default class WrappedSidebar extends React.Component<IBasicProps> {
  public render() {
    const { children, className = '' } = this.props

    return (
      <aside
        className={`tw:absolute tw:right-0 tw:h-[calc(100%-52px)] tw:w-[400px] tw:z-[999] tw:top-[52px] tw:border-0 tw:border-l tw:border-solid tw:border-border tw:bg-background ${className}`}
      >
        {children}
      </aside>
    )
  }
}
